import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg aria-hidden="true" data-prefix="fas" data-icon="pen" className={(styles["svg-inline--fa"] || "svg-inline--fa") + " " + (styles["fa-pen"] || "fa-pen") + " " + (styles["fa-w-16"] || "fa-w-16")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{
  padding: "1px"
}} {...props}><path d="M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6A24 24 0 01.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11a48.02 48.02 0 00-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55a48.02 48.02 0 000-67.91z" /></svg>;